import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/animations.css';
import './styles/index.css';

// Main entry point for the application
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
